import React from 'react'
import Sample from '../sample'

import Text from '../form/form-text'

import CheckedList from '../list/list-checked'
import DraggableList from '../list/list-draggable'
import PagifyList from '../list/list-pagify'
import ExpandableList from '../list/list-expandable'

import './index.styl'
class ListSample extends Sample {

    state = {}

    pathI18n = 'sample.app.components.list.'

    constructor(props) {
        super(props)
        this.getTitle = this.getTitle.bind(this)
        this.getBody = this.getBody.bind(this)
    }

    getTitle() {
        return this.pathI18n + 'page.title'
    }

    getBody() {
        let list = Array.from(new Array(15), (x, i) => <li> {"Element n°" + i}</li>);
        let listChecked = Array.from(new Array(15), (x, i) => ({id: i, label: "Element n°" + i}));
        let {pathI18n} = this

        return <div className="sample sample-list">
            <div><PagifyList current={2} collectionCount={500} elementByPage={5} onClick={e => Promise.resolve()} /></div>
            <div><CheckedList label={pathI18n + 'checkedList.checked'} collection={listChecked} request={e => Promise.resolve(listChecked)}/></div>
            <div><CheckedList className="list-checked-oneResult" label={pathI18n + 'checkedList.oneResult'} collection={listChecked} request={e => Promise.resolve(listChecked)}/></div>
            <div><ExpandableList label={pathI18n + 'expandableList'} collection={listChecked} template={e => <Text label={'app.name'} value={e.label} />}  onChange={console.log}/></div>
            <div><div><DraggableList className="list" duration="300" label={pathI18n + 'draggableList.inline'} collection={list} /></div></div>
            <div><div><DraggableList className="icon" duration="300" label={pathI18n + 'draggableList.icon'} collection={list} /></div></div>
        </div>
    }
}

export default ListSample
